export const QUARTER_LABELS: Record<number, string> = {
    1: "Jan–Mar",
    2: "Apr–Jun",
    3: "Jul–Sep",
    4: "Oct–Dec"
};
